import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { applyStoredThemeEarly } from '@servepod/ui';
import App from './App.vue';
import { router } from './router';
import './styles.css';

applyStoredThemeEarly();

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        // Operators watch these dashboards continuously, so data refreshes on its own.
        // A fleet view that requires a manual reload is a fleet view nobody trusts.
        staleTime: 3_000,
        refetchInterval: 10_000,
        refetchOnWindowFocus: true,
        retry: (failureCount: number, error: unknown) => {
          const status = (error as { status?: number }).status ?? 0;
          if (status >= 400 && status < 500) return false;
          return failureCount < 2;
        },
      },
    },
  },
});

app.mount('#app');
